import type { TripViewDTO } from '@serviquim/contracts';
import { Link } from 'react-router-dom';
import { useT } from '../i18n';
import { formatMoney } from '../lib/money';
import { Card } from './ui/Card';
import { StatusPill } from './ui/StatusPill';

const ACTIVE_STATUSES: ReadonlySet<TripViewDTO['status']> = new Set(['aprovada', 'em_andamento']);

export function TripCard({ trip }: { trip: TripViewDTO }) {
  const { t } = useT();
  const teto = Number(trip.teto);
  const gasto = Number(trip.totalGasto);
  const ratio = teto > 0 ? Math.min(1, gasto / teto) : 0;
  const overBudget = teto > 0 && gasto > teto;
  const isActive = ACTIVE_STATUSES.has(trip.status);

  return (
    <Link to={`/viagens/${trip.id}`} className="block">
      <Card className="flex flex-col gap-3 transition-colors active:bg-surface-raised">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="font-display text-base font-semibold text-ink">
              {trip.origem} → {trip.destino}
            </p>
            <p className="text-sm text-ink-muted">
              {t(trip.dias === 1 ? 'trips.days' : 'trips.daysPlural', { n: trip.dias })}
            </p>
          </div>
          <StatusPill tone={isActive ? 'accent' : 'neutral'}>
            {t(`enums.tripStatus.${trip.status}`)}
          </StatusPill>
        </div>

        {isActive ? (
          <div className="flex flex-col gap-1.5">
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-surface-raised">
              <div
                className={
                  overBudget ? 'h-full rounded-full bg-danger' : 'h-full rounded-full bg-accent'
                }
                style={{ width: `${Math.round(ratio * 100)}%` }}
              />
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="tabular-money text-ink-muted">
                {t('trips.card.spent', { v: formatMoney(trip.totalGasto, trip.moeda) })}
              </span>
              <span className="tabular-money text-ink-muted">
                {t('trips.card.cap', { v: formatMoney(trip.teto, trip.moeda) })}
              </span>
            </div>
          </div>
        ) : null}
      </Card>
    </Link>
  );
}
